/**
 * HapticService — centralized haptic feedback patterns.
 * All methods are no-ops on web.
 */
import { isNative } from '../utils/platform';

function getPlugin() {
  return window.Capacitor?.Plugins?.Haptics || null;
}

const delay = (ms) => new Promise(r => setTimeout(r, ms));

export class HapticService {
  static async tap() {
    const h = getPlugin(); if (!h) return;
    await h.impact({ style: 'LIGHT' });
  }
  static async select() {
    const h = getPlugin(); if (!h) return;
    await h.selectionChanged();
  }
  static async setComplete() {
    const h = getPlugin(); if (!h) return;
    await h.impact({ style: 'MEDIUM' });
  }
  static async personalRecord() {
    const h = getPlugin(); if (!h) return;
    await h.notification({ type: 'SUCCESS' });
    await delay(100);
    await h.impact({ style: 'HEAVY' });
  }
  static async workoutComplete() {
    const h = getPlugin(); if (!h) return;
    await h.notification({ type: 'SUCCESS' });
    await delay(200);
    await h.notification({ type: 'SUCCESS' });
  }
  static async restTimerEnd() {
    const h = getPlugin(); if (!h) return;
    for (let i = 0; i < 3; i++) {
      await h.impact({ style: 'LIGHT' });
      await delay(120);
    }
  }
  static async restTimerTick() {
    const h = getPlugin(); if (!h) return;
    await h.impact({ style: 'LIGHT' });
  }
  static async kmSplit() {
    const h = getPlugin(); if (!h) return;
    await h.impact({ style: 'MEDIUM' });
    await delay(100);
    await h.impact({ style: 'LIGHT' });
  }
  static async aiCoachMessage() {
    const h = getPlugin(); if (!h) return;
    await h.notification({ type: 'WARNING' });
  }
  static async bookingConfirmed() {
    const h = getPlugin(); if (!h) return;
    await h.notification({ type: 'SUCCESS' });
  }
  static async bookingRejected() {
    const h = getPlugin(); if (!h) return;
    await h.notification({ type: 'ERROR' });
  }
  static async error() {
    const h = getPlugin(); if (!h) return;
    await h.notification({ type: 'ERROR' });
  }
}
